import axios from "axios";
import { baseUrl } from "./config";

// Prepare axios instance
const accessToken = localStorage.getItem("access_token");
const request = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
    "Access-Control-Allow-Origin": "*"
  }
});

export default request
